import {Link} from "react-router-dom";

const termCards = [
    {
        title: "Диагностика",
        time: "от 30 минут",
        description: "Первичная проверка, чтение ошибок, осмотр узлов и согласование дальнейших действий.",
    },
    {
        title: "Плановое ТО",
        time: "от 2 часов",
        description: "Замена расходников, базовая проверка систем и подготовка техники к дальнейшей работе.",
    },
    {
        title: "Ремонтные работы",
        time: "по согласованию",
        description: "Срок зависит от сложности ремонта, наличия деталей и объёма дополнительных проверок.",
    },
];

const termFactors = [
    "сложность неисправности и доступность узла;",
    "наличие запчастей на складе или срок поставки;",
    "необходимость дополнительной диагностики после разборки;",
    "загруженность сервиса и приоритетность заявки.",
];

function Terms() {
    return (
        <main className="terms-page">
            <section className="terms-hero">
                <div className="terms-hero-content">
                    <span className="terms-eyebrow">Сроки выполнения</span>
                    <h1>Примерные сроки работ</h1>
                    <p className="terms-hero-description">
                        Здесь будет информация о том, сколько обычно занимает диагностика,
                        плановое обслуживание и ремонт грузовой техники. Точные сроки всегда
                        зависят от состояния автомобиля, доступности запчастей и объёма работ.
                    </p>
                </div>

                <Link className="terms-home-link" to="/">
                    На главную
                </Link>
            </section>

            <section className="terms-section">
                <div className="terms-section-heading">
                    <span>Ориентиры</span>
                    <h2>Базовые временные рамки</h2>
                </div>

                <div className="terms-grid">
                    {termCards.map((card) => (
                        <article className="terms-card" key={card.title}>
                            <span>{card.time}</span>
                            <h3>{card.title}</h3>
                            <p>{card.description}</p>
                        </article>
                    ))}
                </div>
            </section>

            <section className="terms-section terms-info-panel">
                <div>
                    <span className="terms-eyebrow">Важно учитывать</span>
                    <h2>Что влияет на сроки</h2>
                </div>

                <ul>
                    {termFactors.map((factor) => (
                        <li key={factor}>{factor}</li>
                    ))}
                </ul>
            </section>
        </main>
    );
}

export default Terms;
